import { getIQProgress } from "../../../utils/footballIQ";
import styles from "./IQProgressBar.module.css";

/**
 * Football IQ progression.
 *
 * Shows the number, the level name, and how far to the next level,
 * so the bar reads as encouragement rather than as a score.
 */
const IQProgressBar = ({ iq = 0, showLabel = true, size = "md", className = "" }) => {
  const { level, nextLevel, percent, pointsToNextLevel, iq: value } =
    getIQProgress(iq);

  return (
    <div className={`${styles.IQProgressBar} ${styles[size] ?? ""} ${className}`.trim()}>
      {showLabel && (
        <div className={styles.header}>
          <span className={styles.levelName}>
            <i className={level.icon} aria-hidden="true" /> {level.label}
          </span>
          <span className={`${styles.value} app-numeric`}>
            {value} <span className={styles.unit}>IQ</span>
          </span>
        </div>
      )}

      <div
        className={styles.track}
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`Football IQ ${value}, level ${level.label}`}
      >
        <div className={styles.fill} style={{ width: `${percent}%` }} />
      </div>

      {showLabel && (
        <p className={styles.footnote}>
          {nextLevel
            ? `${pointsToNextLevel} more to reach “${nextLevel.label}”`
            : "You have maxed out. We are onto you."}
        </p>
      )}
    </div>
  );
};

export default IQProgressBar;
